module.exports = __webpack_public_path__ + "img/keitaro-landing-step-3_1.en.1aa9b7df.jpg";